/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */

// JSDocs
// eslint-disable-next-line no-unused-vars
import FaceConfig from './FaceConfig.js'

import { mirror } from '@winds-of-legends/wol-utils'
import FaceShape from './FaceShape.js'

const DEBUG = false

export default class FaceDrawer {
  static WIDTH = 100
  static HEIGHT = 150
  static CENTER = FaceDrawer.WIDTH / 2
  static TOP_SHIFT = 20
  static TOP_SHIFT_EARS = 12
  static TOP_SHIFT_NECK = 70
  static TOP_SHIFT_EYEBROWS = 31
  static TOP_SHIFT_EYES = 38
  static TOP_SHIFT_NOSE = 50
  static TOP_SHIFT_MOUTH = 65

  /**
   * Draw a Portrait, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */
  drawPortrait (ctx, faceConfig, ratio, position) {
    this.drawConfigWithBody(ctx, faceConfig, ratio, () => {
      this.drawNeck(ctx, faceConfig.face, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK, position)

      // FaceShape.underwearTop.forEach(([s, p]) => {
      //   this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
      //     fillStyle: 'white', //'rgba(255,255,255,0.5)',
      //     strokeStyle: 'black',
      //     lineWidth: .25 * ratio
      //   }, position)
      // })
    }, position)
  }

  /**
   * Draw a Portrait, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number, radius:number, shiftTop:number, shiftLeft:number }} position
   */
  drawMedalPortrait (ctx, faceConfig, ratio, position, debug) {
    ctx.beginPath()
    const radius = position.radius || 1
    const shiftTop = position.shiftTop || 1
    const shiftLeft = position.shiftLeft || 1
    ctx.arc(ratio * 60 + shiftLeft, ratio * 60 + shiftTop, ratio * radius * 55, 0, Math.PI * 2)

    ctx.fillStyle = 'silver'
    ctx.strokeStyle = 'black'
    ctx.lineWidth = ratio * 2
    ctx.fill()
    ctx.stroke()
    ctx.clip()

    this.drawConfigWithBody(ctx, faceConfig, ratio, () => {
      this.drawBodyAndUnderwear(ctx, faceConfig.body, ratio, position, debug)
    }, position)
  }

  /**
   * Draw a Head, without , according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {()=>{}} body
   * @param {{ top:number, left:number }} position
   */
  drawConfigWithBody (ctx, faceConfig, ratio, body, position = { left: 0, top: 0 }) {
    this.drawBackHair(ctx, faceConfig.hair, ratio, FaceDrawer.TOP_SHIFT, position)
    this.drawEars(ctx, faceConfig.face, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_EARS, position)
    if (body && typeof body === 'function') body()
    this.drawFaceContour(ctx, faceConfig.face, ratio, FaceDrawer.TOP_SHIFT, position)
    this.drawEyebrows(ctx, faceConfig.eyebrows, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_EYEBROWS, position)
    this.drawEyes(ctx, faceConfig.eyes, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_EYES, position)
    this.drawNose(ctx, faceConfig.nose, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NOSE, 0, position)
    this.drawMouth(ctx, faceConfig.mouth, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_MOUTH, 0, position)
    this.drawFrontHair(ctx, faceConfig.hair, ratio, FaceDrawer.TOP_SHIFT, position)
  }

  /**
   * Draw a Chibi body, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */
  drawChibiBody (ctx, bodyConfig, ratio, position = { left: 0, top: 0 }, debug) {
    this.drawConfigWithBody(ctx, bodyConfig, ratio, () => {
      const style = {
        fillStyle: 'silver',
        strokeStyle: 'black',
        lineWidth: 1
      }
      const bodyShape = [
        [0, 0], [4, 0], [4, 15], [12, 17],
        [40, 12], [40, 17], [12, 22], [15, 50]
      ]
      const legShape = !bodyConfig.canoe
        ? [
            [0, 50], [10, 50], [10, 70]
          ]
        : [
            [0, 50], [60, 45], [80, 40], [75, 60], [60, 70]
          ]

      this.drawSymmetricShape(ctx, legShape, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK, style, position, debug)
      this.drawSymmetricShape(ctx, bodyShape, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK, style, position, debug)
    }, position)
  }

  /**
   * Draw a FullSize body, according to given faceConfig
   * @param {CanvasRenderingContext2D} ctx
   * @param {FaceConfig} faceConfig
   * @param {number} ratio
   * @param {{ top:number, left:number }} position
   */
  drawFullSizeBody (ctx, bodyConfig, ratio, position = { left: 0, top: 0 }, debug) {
    this.drawConfigWithBody(ctx, bodyConfig, ratio, () => {
      this.drawBodyAndUnderwear(ctx, bodyConfig.body, ratio, position, debug)
    }, position)
    /*
    if< (DEBUG || debug) {
      const SHIFT = 25
        , INTERVAL = 25
        , UNSHIFT = 90
      for (let i = 0; i < 50; i++) {
        ctx.strokeStyle = i % 2 === 0 ? 'silver' : 'gray'
        ctx.beginPath()
        ctx.setLineDash([5, 15])
        const noratio = i * INTERVAL + SHIFT
        const vertical = ratio * noratio
        ctx.moveTo(0, vertical)
        ctx.lineTo(100, vertical)
        ctx.stroke()
        ctx.font = '9px serif'
        ctx.fillText(noratio - UNSHIFT, 20, vertical - 5)
      }
    }
    */
  }

  drawBodyOnly (ctx, type, ratio, position, debug) {
    FaceShape.bodyShape[type].forEach(([s, p]) => {
      this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
        fillStyle: 'white',
        strokeStyle: 'black',
        lineWidth: 0.25 * ratio
      }, position, debug)
    })
  }

  drawBodyAndUnderwear (ctx, type, ratio, position, debug) {
    FaceShape.bodyShape[type].forEach(([s, p]) => {
      this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
        fillStyle: 'white',
        strokeStyle: 'black',
        lineWidth: 0.25 * ratio
      }, position, debug)
    })
    if (type === 0) {
      /*
      FaceShape.swimSuit.forEach(([s, p]) => {
        this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
          fillStyle: 'gray', // 'rgba(255,255,255,0.5)',
          strokeStyle: 'black',
          lineWidth: 0.25 * ratio
        }, position, debug)
      })
      // */
      //*
      FaceShape.underwearDress.forEach(([s, p]) => {
        this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
          fillStyle: 'silver', // 'rgba(255,255,255,0.5)',
          strokeStyle: 'black',
          lineWidth: 0.25 * ratio
        }, position, debug)
      })
      // */
    } else {
      FaceShape.underwearBottom.forEach(([s, p]) => {
        this.drawSymmetricShape(ctx, p, ratio, FaceDrawer.TOP_SHIFT + FaceDrawer.TOP_SHIFT_NECK + s, {
          fillStyle: 'silver', // 'rgba(255,255,255,0.5)',
          strokeStyle: 'black',
          lineWidth: 0.25 * ratio
        }, position, debug)
      })
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   */
  clean (ctx, ratio) {
    ctx.clearRect(0, 0, ratio * FaceDrawer.WIDTH, ratio * FaceDrawer.HEIGHT)
  }

  cleanAll (ctx) {
    ctx.reset()
    // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */
  drawShape (ctx, shape, ratio, marginTop, drift = 0, style = {}, position = { left: 0, top: 0 }) {
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.strokeStyle = style.strokeStyle || 'black'
    ctx.fillStyle = style.fillStyle || 'white'
    ctx.lineWidth = (style.lineWidth || 0.25) * ratio

    ctx.beginPath()
    const [x0, y0] = shape[0]
    ctx.moveTo(ratio * (FaceDrawer.CENTER + drift + x0) + position.left, ratio * (marginTop + y0) + position.top)
    shape.slice(1).forEach(([x, y]) => {
      ctx.lineTo(ratio * (FaceDrawer.CENTER + drift + x) + position.left, ratio * (marginTop + y) + position.top)
    })
    ctx.fill()
    ctx.stroke()

    if (DEBUG) {
      ctx.fillStyle = style.strokeStyle || 'blue'
      shape.forEach(([x, y]) => {
        ctx.fillRect(ratio * (FaceDrawer.CENTER + drift + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio)
      })
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][][]} shapes
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} drift
   * @param {*} style
   */
  drawMultiShape (ctx, shapes, ratio, marginTop, drift, style = {}, position = { left: 0, top: 0 }) {
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.fillStyle = style.fillStyle || 'black'
    ctx.strokeStyle = style.strokeStyle || 'black'
    ctx.lineWidth = (style.lineWidth || 0.25) * ratio

    shapes.forEach((p) => {
      ctx.beginPath()
      ctx.moveTo(ratio * (FaceDrawer.CENTER + drift + p[0][0]) + position.left, ratio * (marginTop + p[0][1]) + position.top)
      p.slice(1).forEach(([x, y]) => { ctx.lineTo(ratio * (FaceDrawer.CENTER + drift + x) + position.left, ratio * (marginTop + y) + position.top) })
      ctx.fill()
      ctx.stroke()
    })

    if (DEBUG) {
      ctx.fillStyle = style.strokeStyle || 'blue'
      shapes.forEach((p) => {
        p.forEach(([x, y]) => {
          ctx.fillRect(ratio * (FaceDrawer.CENTER + drift + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio)
        })
      })
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {*} style
   */
  drawSymmetricShape (ctx, shape, ratio, marginTop, style = {}, position = { left: 0, top: 0 }, debug = false) {
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.strokeStyle = style.strokeStyle || 'black'
    ctx.fillStyle = style.fillStyle || 'black'
    ctx.lineWidth = (style.lineWidth || 0.25) * ratio

    ctx.beginPath()
    ctx.moveTo(ratio * FaceDrawer.CENTER + position.left, ratio * marginTop + position.top)
    const fullShape = shape.concat(shape.slice().reverse().map(mirror))
    fullShape.forEach(([x, y]) => {
      ctx.lineTo(ratio * (FaceDrawer.CENTER + x) + position.left, ratio * (marginTop + y) + position.top)
    })
    ctx.lineTo(ratio * FaceDrawer.CENTER + position.left, ratio * marginTop + position.top)
    ctx.fill()
    ctx.stroke()

    if (DEBUG || debug) {
      ctx.fillStyle = 'cyan'
      fullShape.forEach(([x, y, ...r]) => {
        if (r.length) {
          const f = ctx.fillStyle
          ctx.fillStyle = r[0]
          const size = r.length > 1 ? r[1] : 2
          ctx.fillRect(
            ratio * (FaceDrawer.CENTER + x - (size / 2)) + position.left,
            ratio * (marginTop + y - (size / 2)) + position.top,
            ratio * size, ratio * size)
          ctx.fillStyle = f
        } else {
          ctx.fillRect(ratio * (FaceDrawer.CENTER + x - 0.5) + position.left, ratio * (marginTop + y - 0.5) + position.top, ratio, ratio)
        }
      })
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */
  drawHairOnly (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawBackHair(ctx, type, ratio, marginTop, position)

    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.fillStyle = 'rgba(200, 200, 200, 0.5)'
    ctx.lineWidth = 0.25 * ratio

    ctx.beginPath()
    ctx.arc(ratio * FaceDrawer.CENTER + position.left, ratio * (FaceDrawer.CENTER - 10) + position.top, ratio * 30, 0, 2 * Math.PI)
    ctx.fill()

    this.drawFrontHair(ctx, type, ratio, marginTop, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   * @param {{ top:number, left:number }} position
   */
  drawBackHair (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawMultiShape(ctx, FaceShape.backHair[type], ratio, marginTop, 0, {
      fillStyle: DEBUG ? 'cyan' : 'black',
      strokeStyle: DEBUG ? 'blue' : 'gray',
      lineWidth: 0.5
    }, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */
  drawFrontHair (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawMultiShape(ctx, FaceShape.frontHair[type], ratio, marginTop, 0, {
      fillStyle: DEBUG ? 'pink' : 'black',
      strokeStyle: DEBUG ? 'red' : 'gray',
      lineWidth: 0.5
    }, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */
  drawNoHairFace (ctx, type, ratio, marginTop, withNeck = true, position = { left: 0, top: 0 }) {
    this.drawEars(ctx, type, ratio, marginTop + FaceDrawer.TOP_SHIFT_EARS, position)
    if (withNeck) this.drawNeck(ctx, type, ratio, marginTop + FaceDrawer.TOP_SHIFT_NECK, position)
    this.drawFaceContour(ctx, type, ratio, marginTop, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */
  drawFaceContour (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawSymmetricShape(ctx, FaceShape.faces[type], ratio, marginTop, {
      strokeStyle: 'black',
      fillStyle: DEBUG ? 'rgba(255, 255, 255, .1)' : 'white'
    }, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   */
  drawNeck (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawSymmetricShape(ctx, FaceShape.necks[type], ratio, marginTop, {
      strokeStyle: DEBUG ? 'green' : 'black',
      fillStyle: DEBUG ? 'rgba(255, 255, 255, .1)' : 'white',
      lineWidth: 0.25 * ratio
    }, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} gap
   */
  drawEars (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    this.drawShape(ctx, FaceShape.ears[type], ratio, marginTop, 0, {}, position)
    this.drawShape(ctx, FaceShape.ears[type].map(mirror), ratio, marginTop, 0, {}, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number[][]} shape
   * @param {number} ratio
   * @param {number} marginTop
   * @param {number} gap
   */
  drawEyebrows (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    const gap = 10
    const style = {
      strokeStyle: DEBUG ? 'green' : 'black',
      fillStyle: DEBUG ? 'rgba(0, 0, 0, .1)' : 'black'
    }

    this.drawShape(ctx, FaceShape.eyebrows[type], ratio, marginTop, gap / 2, style, position)
    this.drawShape(ctx, FaceShape.eyebrows[type].map(mirror), ratio, marginTop, -gap / 2, style, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */
  drawEyes (ctx, type, ratio, marginTop, position = { left: 0, top: 0 }) {
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.strokeStyle = 'black'
    ctx.fillStyle = 'white'
    ctx.lineWidth = 0.25 * ratio

    const eyeShape = FaceShape.eyes[type]

    /**
     * Left eye
     */
    if ('back' in eyeShape) {
      ctx.fillStyle = 'black'
      eyeShape.back.forEach((c) => {
        ctx.beginPath()
        c.forEach(([x, y]) => { ctx.lineTo(ratio * (FaceDrawer.CENTER + x) + position.left, ratio * (marginTop + y) + position.top) })
        ctx.stroke()
        ctx.fill()
      })
      ctx.fillStyle = 'white'
    }

    eyeShape.contour.forEach((c) => {
      ctx.beginPath()
      c.forEach(([x, y]) => { ctx.lineTo(ratio * (FaceDrawer.CENTER + x) + position.left, ratio * (marginTop + y) + position.top) })
      ctx.stroke()
      ctx.fill()
    })

    eyeShape.iris.forEach(([color, x, y, radius, startAngle, endAngle]) => {
      ctx.beginPath()
      ctx.arc(ratio * (FaceDrawer.CENTER + x) + position.left, ratio * (marginTop + y) + position.top, ratio * radius, startAngle, endAngle)
      ctx.fillStyle = color
      ctx.fill()
    })

    /**
     * Right eye
     */
    if ('back' in eyeShape) {
      ctx.fillStyle = 'black'
      eyeShape.back.forEach((c) => {
        ctx.beginPath()
        c.forEach(([x, y]) => { ctx.lineTo(ratio * (FaceDrawer.CENTER - x) + position.left, ratio * (marginTop + y) + position.top) })
        ctx.stroke()
        ctx.fill()
      })
      ctx.fillStyle = 'white'
    }

    eyeShape.contour.forEach((c) => {
      ctx.beginPath()
      c.forEach(([x, y]) => { ctx.lineTo(ratio * (FaceDrawer.CENTER - x) + position.left, ratio * (marginTop + y) + position.top) })
      ctx.stroke()
      ctx.fill()
    })

    eyeShape.iris.forEach(([color, x, y, radius, startAngle, endAngle]) => {
      ctx.beginPath()
      ctx.arc(ratio * (FaceDrawer.CENTER - eyeShape.shift + x) + position.left, ratio * (marginTop + y) + position.top, ratio * radius, startAngle, endAngle)
      ctx.fillStyle = color
      ctx.fill()
    })
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */
  drawNose (ctx, type, ratio, marginTop, drift, position = { left: 0, top: 0 }) {
    const style = {
      strokeStyle: DEBUG ? 'green' : 'black',
      fillStyle: DEBUG ? 'rgba(0, 0, 0, .1)' : 'black'
    }
    this.drawShape(ctx, FaceShape.noses[type], ratio, marginTop, drift, style, position)
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} type
   * @param {number} ratio
   * @param {number} marginTop
   */
  drawMouth (ctx, type, ratio, marginTop, drift = 0, position = { left: 0, top: 0 }) {
    const style = {
      strokeStyle: DEBUG ? 'green' : 'white',
      fillStyle: DEBUG ? 'rgba(0, 0, 0, .1)' : 'gray'
    }
    this.drawMultiShape(ctx, FaceShape.mouths[type], ratio, marginTop, drift, style, position)
  }
}
